import api from 'service/index';
import { ROOT_BASE_URL, REFDATA } from 'constants/url';

import RefData, { Workflows } from 'modules/refData/types/RefData';
import { CountriesRequest, Country, GetCountriesResponse } from './types/Countries';

const refDataApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConfig: build.query<RefData, void>({
      query: () => ({
        method: 'GET',
        url: `${ROOT_BASE_URL}${REFDATA}/config/SO`,
      }),
    }),
    getWorkflows: build.query<Workflows, void>({
      query: () => ({
        method: 'GET',
        url: `${ROOT_BASE_URL}${REFDATA}/selfServices/workflows`,
      }),
    }),
    getCountries: build.query<Country[], CountriesRequest>({
      query: ({ language }) => ({
        method: 'GET',
        url: `${ROOT_BASE_URL}/countries/api/all`,
        params: { language },
      }),
      transformResponse: (response: GetCountriesResponse) => response.content.sort((a, b) => a.name.localeCompare(b.name)),
    }),
  }),
});

export const { useGetCountriesQuery } = refDataApi;

export default refDataApi;
